import * as React from 'react';
import {
  Card,
  CardBody,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Box,
  Divider
} from "@chakra-ui/react";
import { News } from '../models/news';

interface NewsSectionProps {
  news: News[];
}

const NewsSection: React.FC<NewsSectionProps> = ({ news }) => {
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const headingColor = useColorModeValue('green.700', 'green.300');
  const newsCardBg = useColorModeValue('green.50', 'gray.700');
  const newsCardBorder = useColorModeValue('green.200', 'gray.600');
  const newsTitleColor = useColorModeValue('green.600', 'green.400');
  const newsIndexColor = useColorModeValue('gray.500', 'gray.400');
  const newsIndexBg = useColorModeValue('gray.100', 'gray.600');
  const emptyStateTextColor = useColorModeValue('gray.500', 'gray.400');
  const emptyStateSubTextColor = useColorModeValue('gray.400', 'gray.500');

  return (
    <Card
      variant="filled"
      width="100%"
      alignSelf="start"
      bg={cardBg}
      borderColor="green.200"
      borderWidth="2px"
      _hover={{
        transform: 'translateY(-2px)',
        boxShadow: 'xl',
        borderColor: 'green.300'
      }}
      transition="all 0.3s ease-in-out"
    >
      <CardBody p={6}>
        <VStack align="start" spacing={6} width="100%">
          <Box>
            <Heading size="lg" color={headingColor} mb={2}>
              📢 Avisos y novedades
            </Heading>
            <Text fontSize="md" color={textColor}>
              Mantenete al día con las últimas noticias del club:
            </Text>
          </Box>

          <Divider borderColor="green.200" />

          {news.length === 0 ? (
            <Box
              width="100%"
              textAlign="center"
              py={8}
              bg={newsCardBg}
              borderRadius="lg"
              border="1px solid"
              borderColor={newsCardBorder}
            >
              <Text fontSize="md" color={emptyStateTextColor} fontStyle="italic">
                📰 No hay avisos en este momento.
              </Text>
              <Text fontSize="sm" color={emptyStateSubTextColor} mt={2}>
                Revisa más tarde para ver las últimas novedades del club.
              </Text>
            </Box>
          ) : (
            <VStack align="start" spacing={4} width="100%">
              {news.map((newsItem, index) => (
                <Card
                  key={newsItem.id}
                  width="100%"
                  variant="outline"
                  bg={newsCardBg}
                  borderColor={newsCardBorder}
                  borderWidth="1px"
                  _hover={{
                    borderColor: 'green.300',
                    transform: 'translateY(-1px)',
                    boxShadow: 'md'
                  }}
                  transition="all 0.2s ease-in-out"
                >
                  <CardBody p={4}>
                    <VStack align="start" spacing={3}>
                      <Box display="flex" alignItems="center" gap={2}>
                        <Text
                          fontWeight="bold"
                          fontSize="lg"
                          color={newsTitleColor}
                          lineHeight="1.3"
                        >
                          {newsItem.title}
                        </Text>
                        <Text
                          fontSize="xs"
                          color={newsIndexColor}
                          bg={newsIndexBg}
                          px={2}
                          py={1}
                          borderRadius="full"
                        >
                          #{index + 1}
                        </Text>
                      </Box>
                      <Text fontSize="md" color={textColor} lineHeight="1.6">
                        {newsItem.body}
                      </Text>
                    </VStack>
                  </CardBody>
                </Card>
              ))}
            </VStack>
          )}
        </VStack>
      </CardBody>
    </Card>
  );
};

export default NewsSection;
